import { ProductTokens } from '../types'
import { colors, PerthNowPalette } from './colors'

export const perthnow: ProductTokens<PerthNowPalette> = {
    colors,
}

export type PNThemeOverride = 'commonwealth-games' | 'video-carousel'

export * from './colors-ngn'
export * from './metrics'
